<template>
  <div class="columns is-multiline">
    <div class="column is-12 has-text-primary is-italic is-size-5">
      {{ $t('addEditOrdreTravailTech.patrimoine.emplacement.champs.title') }}
    </div>
    <b-field :label="$t('addEditOrdreTravailTech.patrimoine.emplacement.champs.natureSol')"
             class="column is-3 mgb-0 pdt-0">
      <b-input v-model="emplacementTechnique.natureSol"></b-input>
    </b-field>
    <b-field :label="$t('addEditOrdreTravailTech.patrimoine.emplacement.champs.codeBarre')"
             class="column is-3 mgb-0 pdt-0">
      <b-input v-model="emplacementTechnique.codeBarre"></b-input>
    </b-field>
    <b-field :label="$t('addEditOrdreTravailTech.patrimoine' +
     '.emplacement.champs.degreDeniveleTerrain')"
             class="column is-3 mgb-0 pdt-0">
      <b-input v-model="emplacementTechnique.degreDeniveleTerrain" type="number">
      </b-input>
    </b-field>
    <b-field
      :label="$t('addEditOrdreTravailTech.patrimoine.emplacement.champs.accesSiteSurRdv')"
      class="column is-3 mgb-0 pdt-0">
      <b-checkbox v-model="emplacementTechnique.accesSiteSurRdv"></b-checkbox>
    </b-field>
    <b-field :label="$t('addEditOrdreTravailTech.patrimoine.emplacement.champs.acces')"
             class="column is-3 mgb-0 pdt-0">
      <b-input v-model="emplacementTechnique.acces"></b-input>
    </b-field>
    <b-field :label="$t('addEditOrdreTravailTech.patrimoine.emplacement.champs.groupeDhabitation')"
             class="column is-3 mgb-0 pdt-0">
      <b-input v-model="emplacementTechnique.groupeDhabitation"></b-input>
    </b-field>
    <b-field :label="$t('addEditOrdreTravailTech.patrimoine.emplacement.champs.numUg')"
             class="column is-3 mgb-0 pdt-0">
      <b-input v-model="emplacementTechnique.numUG"></b-input>
    </b-field>
    <b-field :label="$t('addEditOrdreTravailTech.patrimoine.emplacement.champs.quartier')"
             class="column is-3 mgb-0 pdt-0">
      <b-input v-model="emplacementTechnique.quartier"></b-input>
    </b-field>
  </div>
</template>

<script>

export default {
  props: {
    emplacementTechnique: {
      type: Object,
      required: true,
    },
  },
};

</script>
